import { StoreState } from '@/redux/types';

export function getActiveUserDraft(state: StoreState) {
  return state.userDrafts.activeDraft;
}
